import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import { useDispatch, useSelector } from "react-redux"//Hooks de redux
import {
  Typography,//Textos
  useMediaQuery,useTheme
} from '@mui/material'//Se importan elementos de la librería material-ui
import {
  AdjustRounded,
  PlayArrowRounded,
  StopRounded
} from '@mui/icons-material'
import Parser from 'html-react-parser';
import Lottie from 'lottie-web-react'
// import { useLottie, Lottie } from "react-lottie-hook";

// import { mainStyles, theme } from '../../styles'
import { fileActions, documentsActions, documentsActionsAsync } from '../../store/actions'//Acciones de redux necesarioas en el stage
// import { useStyles } from './EvidenceStyles'//Estílos específicos de los elementos de este componente
import { coreFunctions } from '../../utils'//Funciones genéricas
import { evidenceFunctions } from './EvidenceFunctions'
import { CustomAlertDialog, CustomLoadingOverlay, Buttons } from '../../components'
import { blobToBase64 } from '../../utils'
import { set } from 'date-fns'
// import animationData from '../../assets/animation_audio.json'
import { useTranslation } from 'react-i18next';

import { flatten } from 'lottie-colorify';

export default function EvidenceAudioComponent(props) {
  // const ref = React.useRef(null);
  const matches = useMediaQuery('(max-width:812px)')
  const { useState, useEffect } = React
  const gridContainer = {} //mainStyles.gridStyle()
   const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
  const localStyles = {}//useStyles()//estílos de este componente (DynamicFormStyles.js)
  const navigate = useNavigate()//Módulo "History" de react router

  const [loadView, setLoadView] = useState(false)
  const [fileId, setFileId] = useState(0)
  const [fileInfoLoad, setFileInfoLoad] = useState(false)
  const [activeVideoEvidence, setActiveVideoEvidence] = useState("0")
  const [loadFileText, setLoadFileText] = useState(false)
  const [evidenceDate, setEvidenceDate] = useState("")
  const [auditoText, setAudioText] = useState("Instrucciones")
  const [marqueeText, setMarkeeText] = useState("Instrucciones")

  const [dataAudio, setDataAudio] = useState(null)
  const [playRecord, setPlayRecord] = useState(true)
  const [stopRecord, setStopRecord] = useState(false)
  const [mrGrabacion, setMRGrabacion] = useState(null)
  const [activeButtonsOptions, setActiveButtonsOptions] = useState(false)
  const [timerSeconds, setTimerSeconds] = useState(0)
  const [datab64, setDatab64] = useState(null)
  const [dataBlob, setDataBlob] = useState(null)

  const { t } = useTranslation();

  const [playingState, setPlayingState] = useState('stop') // setPlayingState('play') , 'pause' or 'stop

  let watchAnimationData = require('../../assets/animation_audio.json')
  const renderer = 'svg'
  const rendererSettings = {
    preserveAspectRatio: 'xMinYMin slice',
    className: localStyles.lottieImgColor,

  }

  let globalStream = null;
  // let mediaRecorder = null;
  let recordedChunks = [];
  const config = { mimeType: 'audio/webm' };

  //Redux hooks
  const auth = useSelector(state => state.Authentication)
  const fileText = useSelector(state => state.FileText)
  const file = useSelector(state => state.FileInfo)

  const wf = useSelector(state => state.Workflow)
  const uploadDocSecContent = useSelector(state => state.UploadDocSectionContent)
  const documentUpEvidence = useSelector(state => state.DocumentUploadEvidence)
  const dispatch = useDispatch()//constate dispatch que ejecutará las acciones

  // Dispose the Video.js player when the functional component unmounts
  useEffect(() => {
    setFileId(location.state.folioId)
    dispatch(fileActions.GetFileInfo(location.state.folioId))
    setFileInfoLoad(true)
  }, []);

  useEffect(() => {
    setLoadView(file.loading)
    //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
    if (file.items != undefined && fileInfoLoad) {
      dispatch(fileActions.GetTextEvidence(file.items.Id))
      setLoadFileText(true)
      let actVideoEvidence = file.items.Stage.Properties.find(element => element.Name == "ActiveVideoEvidence")

      setActiveVideoEvidence(actVideoEvidence?.Value)
    }
  }, [file])

  useEffect(() => {
    if (fileText.items != undefined && loadFileText) {
      setLoadFileText(false)
      console.log("fileText:---------EVIDENCE--- ", fileText)
      setEvidenceDate(fileText.items.EvidenceDate)
      setAudioText(fileText.items.TextAudioEvidence)
      setMarkeeText(fileText.items.TextVideoEvidence)
    } else if (fileText.error != undefined && loadFileText) {
      setLoadFileText(false)
      console.log("Error: ", fileText.error)
    }
  }, [fileText])//Ejecutará el contenido de useEffect cada vez que 'file' se actualice

  useEffect(() => {
    if (stopRecord) {
      if (timerSeconds > 100000) {
        //Activa la variable para el boton
        setTimerSeconds(0)
      }
      // salir cuando lleguemos a 0
      if (timerSeconds > 100000) return;

      // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
      const intervalId = setInterval(() => {
        setTimerSeconds(timerSeconds + 1)
      }, 1000);

      // clear interval al volver a renderizar para evitar pérdidas de memoria
      return () => clearInterval(intervalId);
    }
  }, [timerSeconds, stopRecord]);

  const handlerStart = () => {
    setDataAudio(null)
    setDatab64(null)
    setTimerSeconds(0)
    setPlayingState('play')

    let mediaRecorder = new MediaRecorder(globalStream, config);
    mediaRecorder.addEventListener('dataavailable', (e) => {
      console.log("Sdataavailable----EVET-----: ", e.data)
      if (e.data.size > 0) {
        recordedChunks.push(e.data);
      }
    });

    mediaRecorder.addEventListener('stop', function () {
      console.log("Se detuvo la grabacion de audio.")
      // Create object url from blob.
      let blob = new Blob(recordedChunks);
      setDataBlob(blob)
      const objectRef = URL.createObjectURL(blob);
      setDataAudio(objectRef)

      blobToBase64(blob).then(res => {
        console.log("blobToBase64--------AUDIO----------", res)
        setDatab64(res)
      });
      setPlayingState('stop')

      // Reset instance recorder.
      recordedChunks = [];
      // mediaRecorder = null;
      setMRGrabacion(null)
      setStopRecord(false)
      setPlayRecord(false)
      setActiveButtonsOptions(true)
    });

    console.log("Se inicio la grabacion")
    // Start recorder event of media recorder instance.
    mediaRecorder.start();
    setMRGrabacion(mediaRecorder)
    setPlayRecord(false)
    setStopRecord(true)
    setActiveButtonsOptions(false)
  }

  const handlerEnd = () => {
    console.log("mediaRecorder--- STop--- ", mrGrabacion)
    if (mrGrabacion != null) {
      mrGrabacion.stop();
    }
  }

  // Active permisions of navigator for record audio.
  navigator.mediaDevices
    .getUserMedia({ audio: true, video: false })
    .then((stream) => {
      globalStream = stream;
    });

  const handlerContinue = () => {
    console.log("handlerContinue--- Aceptar--- ", "record.wav", dataAudio)
    console.log("handlerContinue--- Aceptar--- b64 ", datab64)
    let folioId = file.items.Id
    let audiob64 = datab64
    // let audiob64 = dataBlob
    let textAudio = auditoText
    let textVideo = marqueeText
    let dateEvidence = evidenceDate
    let nextComponent = "LocationEAudioComponent"
    console.log("nextComponent-------: ", nextComponent, folioId, audiob64, textAudio, textVideo, dateEvidence)
    evidenceFunctions.doNextStage({ auth ,navigate,nextComponent, folioId, audiob64, textAudio, textVideo, dateEvidence })
  }

  function fmtMSS(s) {
    return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s
  }

  return (<div className={gridContainer.container}>
    <div className={gridContainer.leftColumn}></div>
    <div className={gridContainer.centerColumn}>
      <div className={gridContainer.centerContent}>
        <Typography variant="h6"
          gutterBottom
          
          ><b>{t("audio_recording")}</b></Typography>
        {activeButtonsOptions ?
          <Typography variant="subtitle1"
            gutterBottom
              >{t("before_audio_recording")}</Typography>
          :
          <Typography variant="subtitle1"
            gutterBottom
              >{t("press_button_read_text")}: </Typography>
        }
        <div className={localStyles.centerContenMessage}>
          {activeButtonsOptions ?
            <div className={localStyles.textContent}>
              <div className={localStyles.containerImageLot}>
                <div className={localStyles.lottieImg}>
                  <Lottie
                    // className={localStyles.lottieImg}
                    options={{
                      renderer: renderer,
                      loop: true,
                      autoplay: true,
                      animationData: flatten(theme.palette.primary.main, watchAnimationData),
                      rendererSettings: rendererSettings,
                    }}
                    playingState={playingState}
                  />
                </div>
              </div>
              <audio id="player" src={dataAudio} controls controlslist="nodownload" preload='auto'  ></audio>
            </div>
            : <div className={localStyles.textContent}>
              <Typography variant="subtitle2"
                gutterBottom
                  >{auditoText != undefined && auditoText != '' ? Parser(auditoText) : ""}</Typography>
              <div className={localStyles.containerImageLot}>
                <div className={localStyles.lottieImg}>
                  <Lottie
                    // className={localStyles.lottieImg}
                    options={{
                      renderer: renderer,
                      loop: true,
                      autoplay: true,
                      animationData: flatten(theme.palette.primary.main, watchAnimationData),
                      rendererSettings: rendererSettings,
                    }}
                    playingState={playingState}
                  />
                </div>
              </div>
              <Typography variant="subtitle1"
                gutterBottom
                  >00:{fmtMSS(timerSeconds)}</Typography>
            </div>
          }
        </div>
        {activeButtonsOptions ?
          <div className={localStyles.buttonCont1}>
            <Buttons
              text_color="#FFFFFF"
              background_color={theme.palette.primary.main}
              border_color={theme.palette.primary.main}
              text={t("general_accept")}
              type="button"
              size={100}
              className={localStyles.continueBtn}
              click={handlerContinue}
            />

            <Buttons
              text_color={theme.palette.primary.main}
              background_color="#FFFFFF"
              border_color={theme.palette.primary.main}
              text="Volver a grabar"
              type="button"
              size={100}
              className={localStyles.continueBtn}
              click={handlerStart}
            />
          </div> : null}


      </div>
      <div className={activeButtonsOptions ? localStyles.buttonContains1 : localStyles.buttonContains}>
        {activeButtonsOptions ? null :
          <div className={localStyles.buttonCont}>
            {playRecord &&
              <AdjustRounded className={localStyles.iconsStyle} onClick={handlerStart} />
            }
            {stopRecord &&
              <StopRounded className={localStyles.iconsStyle} onClick={handlerEnd} />
            }
          </div>
        }
      </div>
    </div>
    <div className={gridContainer.rightColumn}></div>
  </div>
  )
}